export default "__VITE_ASSET__oMadfiAj__"